import React from 'react'
import { IconAction, withColors, withMargins } from '@olxbr/ds-web'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledIcon = styled(IconAction)`
  ${withColors};
  ${withMargins};
  & > .ds-link-icon-wrapper {
    background-color: ${({ customBgColor, bgColor }) => customBgColor || `var(${bgColor})`};
  }
`

const IconButton = ({ children, color = '--color-neutral-70', ...restProps }) => {
  return <StyledIcon className="interactive" color={color} icon={children} {...restProps} />
}

IconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  customBgColor: PropTypes.string,
  color: PropTypes.string,
}

export { IconButton }
